import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  error: boolean;
  message: string;
};

const initialState: StateInterface = {
  isFetching: false,
  error: false,
  message: ""
};

export const signoutReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.PAGE_SIGNOUT_REQUEST:
      return { ...state,
        isFetching: true,
        error: false
      };

    case Constants.PAGE_SIGNOUT_SUCCESS:
      return { ...state,
        isFetching: false
      };

    case Constants.PAGE_SIGNOUT_FAILURE:
      return { ...state,
        isFetching: false,
        message: action.payload?.err.message,
        error: true
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
